/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateTenantApiData } from '../../../screens/Dashboard/Tenants/_partials/TenantsRecord/TenantsRecord.types';

interface ITenants {
  createTenantApiData: CreateTenantApiData;
  isShowTenantsModal: boolean;
  activeTenantsModal:
    | 'addTenantsModal'
    | 'addTenantsSuccessModal'
    | 'reviewScheduleModal'
    | 'accountSetupModal'
    | 'paymentMethodDetailsModal'
    | 'addPropertyRedirectModal'
    | '';
  propertyLists: any;
  refetchGetTenantsDetails: boolean;
}

const initialState: ITenants = {
  createTenantApiData: {},
  isShowTenantsModal: false,
  activeTenantsModal: '',
  propertyLists: [],
  refetchGetTenantsDetails: false
};

const tenantsSlice = createSlice({
  name: 'tenants',
  initialState,
  reducers: {
    setIsShowTenantsModal: (state: ITenants, action: PayloadAction<boolean>) => {
      state.isShowTenantsModal = action.payload;
    },
    setActiveTenantsModal: (
      state: ITenants,
      action: PayloadAction<
        | 'addTenantsModal'
        | 'addTenantsSuccessModal'
        | 'reviewScheduleModal'
        | 'accountSetupModal'
        | 'paymentMethodDetailsModal'
        | 'addPropertyRedirectModal'
        | ''
      >
    ) => {
      state.activeTenantsModal = action.payload;
    },
    setCreateTenantApiData: (state: ITenants, action: PayloadAction<any>) => {
      state.createTenantApiData = action.payload;
    },
    setPropertyLists: (state: ITenants, action: PayloadAction<any>) => {
      state.propertyLists = action.payload;
    },
    setRefetchGetTenantsDetails: (state, action: PayloadAction<boolean>) => {
      state.refetchGetTenantsDetails = action.payload;
    }
  }
});

export const {
  setIsShowTenantsModal,
  setActiveTenantsModal,
  setCreateTenantApiData,
  setPropertyLists,
  setRefetchGetTenantsDetails
} = tenantsSlice.actions;

export default tenantsSlice.reducer;
